import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-campaign-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './add-campaign-page.component.html',
  styleUrls: ['./add-campaign-page.component.css']
})
export class AddCampaignPageComponent {

}
